import { useSelector } from 'react-redux';
import { formatAccessDeniedMessage, getActionDeniedTemplate } from '../utils/accessDeniedMessage';

export function useAccessDeniedMessage(templateKey = 'action_denied') {
  const rootUserEmail = useSelector((state) => state.org.org?.root_user_email ?? '');
  const template = getActionDeniedTemplate("", templateKey);

  return formatAccessDeniedMessage(template, rootUserEmail);
}
